import * as React from 'react';
import { withRouter } from "react-router-dom";
import Drawer from '../Drawer';

function Header(props){
 if(props.history.location.pathname === '/' || props.history.location.pathname === '/login'){
   localStorage.clear()
 }
return (
  <div><Drawer customProps={props}/></div>
)

}
export default withRouter(Header);

